var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "member-management" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "销售明细查询", name: "list" } },
            [
              _c("div", { staticClass: "search-area" }, [
                _c(
                  "div",
                  { staticClass: "search-content" },
                  [
                    _c(
                      "el-form",
                      {
                        staticClass: "search-form",
                        attrs: { inline: true, model: _vm.searchForm },
                      },
                      [
                        _c(
                          "el-form-item",
                          [
                            _c("el-date-picker", {
                              attrs: {
                                type: "datetimerange",
                                "range-separator": "至",
                                "start-placeholder": "开始时间",
                                "end-placeholder": "结束时间",
                                format: "yyyy-MM-dd HH:mm:ss",
                                "value-format": "yyyy-MM-dd HH:mm:ss",
                                clearable: "",
                                "default-time": ["00:00:00", "23:59:59"],
                              },
                              model: {
                                value: _vm.searchForm.regTimeRange,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "regTimeRange", $$v)
                                },
                                expression: "searchForm.regTimeRange",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-form-item",
                          [
                            _c(
                              "el-select",
                              {
                                staticClass: "shop-select",
                                attrs: {
                                  placeholder: "门店",
                                  clearable: "",
                                  filterable: "",
                                  multiple: "",
                                },
                                model: {
                                  value: _vm.searchForm.storeIds,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.searchForm, "storeIds", $$v)
                                  },
                                  expression: "searchForm.storeIds",
                                },
                              },
                              _vm._l(_vm.storeList, function (shop) {
                                return _c("el-option", {
                                  key: shop.storeId,
                                  attrs: {
                                    label: shop.storeName,
                                    value: shop.storeId,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "action-buttons" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.handleSearch },
                      },
                      [_vm._v("搜索")]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "table-container",
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.saleDetailData,
                border: "",
                "summary-method": _vm.getSummaries,
                "show-summary": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "dateStr",
                  label: "日期",
                  fixed: "",
                  "min-width": "180",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "storeName",
                  label: "门店",
                  fixed: "",
                  "min-width": "150",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "totalOrder",
                  label: "总订单量",
                  "min-width": "100",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "totalAmount",
                  label: "总营业额",
                  "min-width": "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatAmount(scope.row.totalAmount)) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "totalTaxAmount",
                  label: "总含税纯收",
                  "min-width": "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatAmount(scope.row.totalTaxAmount)) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "totalAvgPrice",
                  label: "总客单价",
                  "min-width": "90",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.formatAmount(scope.row.totalAvgPrice)) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "totalRefundAmount",
                  label: "总退款金额",
                  "min-width": "100",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.formatAmount(scope.row.totalRefundAmount)
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: { label: "堂食", "min-width": "300", align: "center" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "dineInAmount",
                      label: "营业额",
                      "min-width": "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.formatAmount(scope.row.dineInAmount)
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "dineInTaxAmount",
                      label: "含税纯收",
                      "min-width": "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.formatAmount(scope.row.dineInTaxAmount)
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "dineInOrder",
                      label: "订单量",
                      "min-width": "90",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "dineInAvgPrice",
                      label: "客单价",
                      "min-width": "90",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.formatAmount(scope.row.dineInAvgPrice)
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: { label: "自提", "min-width": "300", align: "center" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "pickUpAmount",
                      label: "营业额",
                      "min-width": "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.formatAmount(scope.row.pickUpAmount)
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pickUpTaxAmount",
                      label: "含税纯收",
                      "min-width": "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.formatAmount(scope.row.pickUpTaxAmount)
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pickUpOrder",
                      label: "订单量",
                      "min-width": "90",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "pickUpAvgPrice",
                      label: "客单价",
                      "min-width": "90",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.formatAmount(scope.row.pickUpAvgPrice)
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table-column",
                {
                  attrs: { label: "外卖", "min-width": "300", align: "center" },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "takeoutAmount",
                      label: "营业额",
                      "min-width": "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.formatAmount(scope.row.takeoutAmount)
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "takeoutTaxAmount",
                      label: "含税纯收",
                      "min-width": "100",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.formatAmount(scope.row.takeoutTaxAmount)
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "takeoutOrder",
                      label: "订单量",
                      "min-width": "90",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "takeoutAvgPrice",
                      label: "客单价",
                      "min-width": "90",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.formatAmount(scope.row.takeoutAvgPrice)
                                ) +
                                "\n          "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }